<template>  
  <th>
    <slot></slot>
  </th>
</template>
<script>
export default {
  name: 'th-no-sort-field'
}
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Tables/ThNoSortField.vue